import React, { useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/HeroSec/Hero";
import Services from "../components/Services/Services";
import Footer from "../components/Footer/Footer";
import About from "../components/About/About";
import Projects from "../components/Projects/Projects";

const Home = () => {
  useEffect(() => {
    document.title = "Shahzaib Here! A Full Stack Developer, Welcome Peeps!";
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Projects/>
      <Services />
      <Footer />
    </>
  );
};

export default Home;
